import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import s from './MapNoteDropdown.module.scss';

export default class MapNoteDropdown extends Component {
    static propTypes = {
        selectedOption: PropTypes.string,
        onOptionClick: PropTypes.func,
        showOptions: PropTypes.bool,
        onTypeDropdownChange: PropTypes.func.isRequired,
    };

    static defaultProps = {
        selectedOption: '---',
        onOptionClick: () => {},
        showOptions: false,
    };

    changeTypeFormat = type => {
        switch (type) {
            case 'mapRequest':
                return 'Map Request';
            case 'fieldVerify':
                return 'Field Verify';
            case '---':
                return '';
            case 'Map Request':
                return 'mapRequest';
            case 'Field Verify':
                return 'fieldVerify';
            default:
                return '---';
        }
    };

    selectOption = e => {
        const { onOptionClick, onTypeDropdownChange } = this.props;
        onOptionClick(this.changeTypeFormat(e.currentTarget.dataset.id));
        onTypeDropdownChange(false);
    };

    toggleDropdown = () => {
        const { onTypeDropdownChange, showOptions } = this.props;
        onTypeDropdownChange(!showOptions);
    };

    renderOptions = () => {
        const { selectedOption, showOptions } = this.props;
        if (showOptions) {
            return (
                <div className={s.options}>
                    <div>
                        <div className={s.option} onClick={this.selectOption} data-id="---">
                            <div className={classNames(s.label, s.noLabel)}>---</div>
                            <img
                                className={classNames(s.checkmarkIcon, selectedOption === '---' || selectedOption === null ? s.show : s.hide)}
                                src="https://content.locuslabs.com/vms-ui/map-note-icons/tick-new-gray.svg"
                                alt="Checkmark Icon"
                            />
                        </div>
                        <div className={s.option} onClick={this.selectOption} data-id="Map Request">
                            <div className={classNames(s.label, s.mapRequest)}>Map Request</div>
                            <img
                                className={classNames(s.checkmarkIcon, selectedOption === 'Map Request' || selectedOption === 'mapRequest' ? s.show : s.hide)}
                                src="https://content.locuslabs.com/vms-ui/map-note-icons/tick-new-gray.svg"
                                alt="Checkmark Icon"
                            />
                        </div>
                        <div className={s.option} onClick={this.selectOption} data-id="Field Verify">
                            <div className={classNames(s.label, s.fieldVerify)}>Field Verify</div>
                            <img
                                className={classNames(s.checkmarkIcon, selectedOption === 'Field Verify' || selectedOption === 'fieldVerify' ? s.show : s.hide)}
                                src="https://content.locuslabs.com/vms-ui/map-note-icons/tick-new-gray.svg"
                                alt="Checkmark Icon"
                            />
                        </div>
                    </div>
                </div>
            );
        }
    };

    render() {
        const { selectedOption, showOptions } = this.props;

        return (
            <div>
                <div className={s.selected} onClick={this.toggleDropdown}>
                    <div className={s.selectedOption}>
                        <div className={classNames(s.selectedLabel, s.label, selectedOption === 'mapRequest' ? s.mapRequest : selectedOption === 'fieldVerify' ? s.fieldVerify : s.noLabel)}>
                            {this.changeTypeFormat(selectedOption)}
                        </div>
                    </div>
                    <div className={classNames(s.icon, showOptions ? 'icon-triangleup' : 'icon-triangledown')} />
                </div>
                {this.renderOptions()}
            </div>
        );
    }
}
